import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SHARED_IMPORTS } from 'projects/minotaure-lib/src/shared-imports';

@Component({
  selector: 'email-template-preview',
  imports: [SHARED_IMPORTS],
  templateUrl: './email-template-preview.component.html',
  styleUrl: './email-template-preview.component.scss',
})
export class EmailTemplatePreviewComponent {
  private readonly sanitizer = inject(DomSanitizer);

  readonly loading = input<boolean>(false);
  readonly html = input<string | null>(null);

  readonly safeHtml = computed<SafeHtml | null>(() => {
    const html = this.html();
    return html ? this.sanitizer.bypassSecurityTrustHtml(html) : null;
  });
}
